import { render, staticRenderFns } from "./dataHome.vue?vue&type=template&id=739f0748&scoped=true&"
import script from "./dataHome.vue?vue&type=script&lang=js&"
export * from "./dataHome.vue?vue&type=script&lang=js&"
import style0 from "./dataHome.vue?vue&type=style&index=0&id=739f0748&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f0748",
  null
  
)

export default component.exports